import React, { FC } from 'react'
import './TransactionFailed.scss'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { Link } from 'react-router-dom';
import { routingService } from 'app_services/routingService';
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper';
import { ITransactionStatus } from 'app_types/transaction/transactionTypes';

const failedIcon = require('app_assets/images/logos/failed.png')

interface ITransactionFailedProps {
  isLoading: boolean
  transaction: ITransactionStatus
  handleGetDetails: () => JSX.Element
}

const TransactionFailed: FC<ITransactionFailedProps> = ({
  isLoading,
  transaction,
  handleGetDetails
}) => {
  return (
      <div className='transactions-failed--big-container'>
        <LoadingWrapper minHeight='614px' loading={isLoading}>
          <div className='transactions-failed--container'>
            <div className='transactions-failed--title'>Transacción fallida</div>
            <div className='transactions-failed--failed-icon-container'>
              <img className='transactions-failed--failed-icon' src={failedIcon} alt="" />
            </div>
            <div className='transactions-failed--subtitle'>Muchas gracias por confiar en nosotros.</div>
            <div className='transactions-failed--text'>Lo sentimos, en el momento no ha sido posible procesar el pago. Por favor inténtalo más tarde</div>
            <div className='transactions-failed--subtitle'>Información de tu pedido</div>
            <div className='transactions-failed--text-container'>
              {handleGetDetails()}
            </div>
            <Link style={{marginTop: 'auto'}} to={routingService.getSecurePath('?section=certifications')}>
              <ButtonComponent variant='secondary' textTransform='none' width='100%' marginTop='20px'>Volver al sitio</ButtonComponent>
            </Link>
          </div>
        </LoadingWrapper>
    </div>
  )
}

export default TransactionFailed
